<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Initial Message</h3>

    <label>Initial Message (Without customer name)</label>
    <p class="hint">leave blank to disable</p>
    <input v-model="resource.initial_message" type="text" placeholder="Without customer name" />
    <span v-if="errors.initial_message" class="alert -inline -danger">
      {{ [...errors.initial_message].join(', ') }}
    </span>


    <label>Initial Message (With customer name)</label>
    <p class="hint">leave blank to disable</p>
    <input v-model="resource.initial_message_customer" type="text" placeholder="With customer name" />
    <span v-if="errors.initial_message_customer" class="alert -inline -danger">
      {{ [...errors.initial_message_customer].join(', ') }}
    </span>

    <label>Suggested Questions</label>
    <p class="hint">These will be suggested conversation starters when there is no vehicle in the context.</p>
    <form @submit="addSuggestedQuestion">
      <input v-model="newSuggestedQuestion" type="text" />
      <span v-if="error" class="alert -inline -danger">
        {{ error }}
      </span>
      <action-button
        v-else
        text="Add Suggested Questions"
        :state="state"
        @pressed="addSuggestedQuestion"
      ></action-button>
    </form>

    <div v-if="resource.suggested_questions && resource.suggested_questions.length > 0" class="basic-list -mt">
      <hr />
      <ul>
        <li v-for="(suggested_query, index) in resource.suggested_questions" :key="suggested_query">
          {{ suggested_query }}
          <action-button
            :state="state"
            text="Remove"
            class="-danger -small -right"
            @pressed="removeSuggestedQuestion(suggested_query)"
          />
          <span v-if="dig(errors.suggested_questions, index)" class="alert -inline -danger -mt">
            {{ [...dig(errors.suggested_questions, index)].join(', ') }}
          </span>
        </li>
      </ul>
    </div>

    <hr />

    <label>Initial Message Timeout <small>(default: 5)</small></label>
    <p class="hint">
      The amount of time (in seconds) before the initial message is sent (note: the bots write delay will be added on
      top).
    </p>
    <input v-model="resource.initial_message_timeout" type="number" />
    <span v-if="errors.initial_message_timeout" class="alert -inline -danger">
      {{ [...errors.initial_message_timeout].join(', ') }}
    </span>

    <label>Initial Message Max Pops <small>(default: always)</small></label>
    <p class="hint">
      The number of times the 'pop' noise should be played when sending an initial message (per 24 hours).
    </p>
    <select v-model="resource.initial_message_max_pops">
      <option value="-1">Always</option>
      <option value="0">Never</option>
      <option v-for="c in [1, 2, 3, 4, 5]" :key="c" :value="c">{{ c }}</option>
    </select>
    <span v-if="errors.initial_message_max_pops" class="alert -inline -danger">
      {{ [...errors.initial_message_max_pops].join(', ') }}
    </span>

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import dig from "object-dig";
import _ from "underscore";

import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: [
        "initial_message",
        "initial_message_customer",
        "suggested_questions",
        "initial_message_timeout",
        "initial_message_max_pops"
      ],
      error: "",
      newSuggestedQuestion: ""
    };
  },

  methods: {
    dig,
    addSuggestedQuestion() {
      if (this.resource.suggested_questions === undefined) {
        this.resource.suggested_questions = [];
      }
      if (this.resource.suggested_questions.length >= 5) {
        this.error = "You can have a maximum of 5 suggested questions";
      } else if (this.newSuggestedQuestion.trim().length > 0) {
        this.resource.suggested_questions.push(this.newSuggestedQuestion.trim());
        this.resource.suggested_questions = _.uniq(this.resource.suggested_questions);

        this.newSuggestedQuestion = "";
        this.submit();
      }
    },

    removeSuggestedQuestion(email) {
      const dupe = _.clone(this.resource);
      dupe.suggested_questions = _.without(dupe.suggested_questions, email);
      this.resource = dupe;
      this.submit();
      this.error = "";
    }
  }
};
</script>
